import NavBar from "../Navbar/Navbar";
import getCookie, { setAdminCookie, userState } from "../../Atom";
import { useRecoilState, useRecoilValue } from "recoil";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getUsersAdmin } from "../School-Districts/api";
import ReactPaginate from "react-paginate";
import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import "./style.css";
import { SignupAdmin, EditAdmin, DeleteAdmin } from "../Auth/LoginPage/Api";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
// import Typography from "@material-ui/core/Typography";
import DialogTitle from "@mui/material/DialogTitle";
// import Box from '@mui/material/Box';
import {
  createDistrictAdminManually,
  createFullNewTeacher,
  editTeacherDetails,
  deleteTeacherDetails,
  GetEverySchoolByDistrict,
  getSchoolDistrictsById,
  deleteSchoolDistrictsAdmin,
  editSchoolDistrictsAdmin,
  passwordChangeTeacher,
  passwordChangeDistrictAdmin,
  passwordChangeSuperAdmin,
} from "../School-Districts/api";

import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import UserTable from "./UserTable";
import {
  Paper,
  Table,
  TableCell,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const headCells = [
  {
    id: "type",
    numeric: false,
    disablePadding: true,
    label: "UserType",
  },
  {
    id: "fName",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },
  {
    id: "createdAt",
    numeric: true,
    disablePadding: true,
    label: "Created On",
  },
];
const headTeacherCells = [
  {
    id: "userType",
    numeric: false,
    disablePadding: true,
    label: "UserType",
  },
  {
    id: "fName",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },
  {
    id: "schoolDistrictName",
    numeric: false,
    disablePadding: true,
    label: "SchoolDistrict",
  },
  {
    id: "schoolName",
    numeric: false,
    disablePadding: true,
    label: "School",
  },
  {
    id: "createdAt",
    numeric: true,
    disablePadding: true,
    label: "Created On",
  },
];
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            key={headCell?.id}
            // align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell?.id ? order : false}
          >
            <TableSortLabel
              className="sort-header"
              sx={{
                display: "flex",
                justifyContent: "left !important",
              }}
              active={orderBy === headCell?.id}
              direction={orderBy === headCell?.id ? order : "asc"}
              onClick={createSortHandler(headCell?.id)}
            >
              {headCell?.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTeacherTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headTeacherCells?.map((headCell) => (
          <TableCell
            key={headCell?.id}
            // align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell?.id ? order : false}
          >
            <TableSortLabel
              className="sort-header"
              sx={{
                display: "flex",
                justifyContent: "left !important",
              }}
              active={orderBy === headCell?.id}
              direction={orderBy === headCell?.id ? order : "asc"}
              onClick={createSortHandler(headCell?.id)}
            >
              {headCell?.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
EnhancedTeacherTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const EnhancedTableToolbar = (props) => {
  // const { numSelected } = props;
  return <div className="pt-10"></div>;
};
EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function User() {
  const [value, setValue] = useState(0);
  const [selected, setSelected] = useState([]);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [pageLimit, setPageLimit] = useState(25);
  const [rowsPerPage, setRowsPerPage] = useState(pageLimit);
  const handleChange = (event, newValue) => {
    if (newValue == 1) setCurrentUser("district");
    else if (newValue == 2) setCurrentUser("teacher");
    else setCurrentUser("admin");
    setValue(newValue);
    let currentPhase =
      newValue == 1 ? "district" : newValue == 2 ? "teacher" : "admin";
    history.replace({
      pathname: "/users",
      search: `?spage=${urlParam.superPage}&slimit=${urlParam.superLimit}&squery=${urlParam.superQuery}&sorderBy=${urlParam.superOrderBy}&sorder=${urlParam.superOrder}&dpage=${urlParam.superPage}&dlimit=${urlParam.districtLimit}&dquery=${urlParam.districtQuery}&dorderBy=${urlParam.districtOrderBy}&dorder=${urlParam.districtOrder}&tpage=${urlParam.teacherPage}&tlimit=${urlParam.teacherLimit}&tquery=${urlParam.teacherQuery}&torderBy=${urlParam.teacherOrderBy}&torder=${urlParam.teacherOrder}&delTpage=${urlParam.delTeacherPage}&delTlimit=${urlParam.delTeacherLimit}&delTquery=${urlParam.delTeacherQuery}&delTorderBy=${urlParam.delTeacherOrderBy}&delTorder=${urlParam.delTeacherOrder}&current=${currentPhase}`,
    });
  };
  const [open, setOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState("admin");
  const history = useHistory();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const [myUser, setmyUser] = useState(userState);
  const [currPage, setCurrPage] = useState({
    scurrPage: 0,
    dcurrPage: 0,
    tcurrPage: 0,
    delTcurrPage: 0,
  });
  const [sortType, setSortType] = useState("All");
  const [allUsers, setAllUsers] = useState([]);
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [query, setQuery] = useState("");
  const [districtSelect, setDistrictSelect] = useState("");
  const [allDistrict, setAllDistrict] = useState([]);
  const [districtAdmins, setDistrictAdmins] = useState([]);
  const [allSchools, setAllSchools] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [deletedTeachers, setDeletedTeachers] = useState([]);
  const [superAdmins, setSuperAdmins] = useState([]);
  const [adminId, setAdminId] = useState("");
  const [selectDistrictId, setSelectDistrictId] = useState("");
  const [selectSchoolId, setSelectSchoolId] = useState("");
  const [districtAdminId, setDistrictAdminId] = useState("");
  const [teacherId, setTeacherId] = useState("");
  const [snoOfPages, setSNoOfPages] = useState(25);
  const [dnoOfPages, setDNoOfPages] = useState(25);
  const [tnoOfPages, setTNoOfPages] = useState(25);
  const [delTnoOfPages, setDelTNoOfPages] = useState(25);
  const [districtAdminMobile, setDistrictAdminMobile] = useState("");
  const emailRegex =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  const [showInfo, setShowInfo] = useState(false);
  const [districtName, setDistrictName] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [user, setUser] = useState({});
  const [urlParam, setUrlParam] = useState({
    superPage: 0,
    superLimit: 25,
    superQuery: "",
    superOrderBy: "createdAt",
    superOrder: "desc",
    districtPage: 0,
    districtLimit: 25,
    districtQuery: "",
    districtOrderBy: "createdAt",
    districtOrder: "desc",
    teacherPage: 0,
    teacherLimit: 25,
    teacherQuery: "",
    teacherOrderBy: "createdAt",
    teacherOrder: "desc",
    delTeacherPage: 0,
    delTeacherLimit: 25,
    delTeacherQuery: "",
    delTeacherOrderBy: "createdAt",
    delTeacherOrder: "desc",
  });
  const [admin, setAdmin] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
  });
  const [district, setDistrict] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
    mobile: "",
  });
  const [teacher, setTeacher] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
  });

  const [teacherTouched, setTeacherTouched] = useState({
    fName: false,
    lName: false,
    email: false,
    password: false,
  });

  const [adminTouched, setAdminTouched] = useState({
    fName: false,
    lName: false,
    email: false,
    password: false,
  });

  const [districtTouched, setDistrictTouched] = useState({
    fName: false,
    lName: false,
    email: false,
    password: false,
    mobile: false,
  });

  const [modified, setModified] = useState({
    add: false,
    edit: false,
    delete: false,
  });

  const [passwordState, setPasswordState] = useState(false);
  const [password, setPassword] = useState("");
  const [teacherSubTab, setTeacherSubTab] = useState(0);

  const handleTeacherSubTabChange = (event, newValue) => {
    setTeacherSubTab(newValue);
  };
  const logoutHandler = async () => {
    setTimeout(() => {
      //   setmyUser({
      //     fName: null,
      //     userId: null,
      //     token: null,
      //     lName: null,
      //   })
      setAdminCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      window.location.assign(
        `${window.location.protocol}//${hostname}/super-admin`
      );
    });
  };

  const info = (user, type) => {
    setUser(user);
    if (type == "admin") {
      setAdmin({
        fName: user.fName,
        lName: user.lName,
        email: user.email,
      });
    } else if (type == "district") {
      setSelectDistrictId(user.schoolDistrict._id);
      setDistrict({
        fName: user.fName,
        lName: user.lName,
        email: user.email,
        mobile: user.mobile,
      });
      setDistrictName(user?.schoolDistrict?.name);
    } else {
      setTeacher({
        fName: user.fName,
        lName: user.lName,
        email: user.email,
        emailF: user.emailF,
        deleted: user.deleted,
      });
      setDistrictName(user?.schoolDistrict?.name);
      setSchoolName(user?.school?.name);
    }
    setShowInfo(true);
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  const handleChangeDistrict = async (event) => {
    setSelectDistrictId(event.target.value);
    if (currentUser == "teacher") {
      getSchools(event.target.value);
      let res = await getSchoolDistrictsById(event.target.value, myUser.token);
      if (!res.error) {
        let districts = res.res.data.data.schoolDistrict;
        if (districts.schoolId) {
          setSelectSchoolId(districts.schoolId);
        }
      }
    }
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const onSetOrder = (event, property) => {
    let orderTemp = order === "asc" ? "desc" : "asc";
    if (currentUser == "admin") {
      setUrlParam({
        ...urlParam,
        superOrderBy: property,
        superOrder: orderTemp,
      });
      setOrder(orderTemp);
      getUsers(
        urlParam.superPage,
        urlParam.superLimit,
        urlParam.superQuery,
        property,
        orderTemp,
        urlParam.districtPage,
        urlParam.districtLimit,
        urlParam.districtQuery,
        urlParam.districtOrderBy,
        urlParam.districtOrder,
        urlParam.teacherPage,
        urlParam.teacherLimit,
        urlParam.teacherQuery,
        urlParam.teacherOrderBy,
        urlParam.teacherOrder,
        urlParam.delTeacherPage,
        urlParam.delTeacherLimit,
        urlParam.delTeacherQuery,
        urlParam.delTeacherOrderBy,
        urlParam.delTeacherOrder
      );
      history.replace({
        pathname: "/users",
        search: `?spage=${urlParam.superPage}&slimit=${urlParam.superLimit}&squery=${urlParam.superQuery}&sorderBy=${property}&sorder=${orderTemp}&dpage=${urlParam.districtPage}&dlimit=${urlParam.districtLimit}&dquery=${urlParam.districtQuery}&dorderBy=${urlParam.districtOrderBy}&dorder=${urlParam.districtOrder}&tpage=${urlParam.teacherPage}&tlimit=${urlParam.teacherLimit}&torderBy=${urlParam.teacherOrderBy}&torder=${urlParam.teacherOrder}&delTquery=${urlParam.delTeacherQuery}&delTpage=${urlParam.delTeacherPage}&delTlimit=${urlParam.delTeacherLimit}&delTquery=${urlParam.delTeacherQuery}&delTorderBy=${urlParam.delTeacherOrderBy}&delTorder=${urlParam.delTeacherOrder}&current=${currentUser}`,
      });
    } else if (currentUser == "district") {
      setUrlParam({
        ...urlParam,
        districtOrderBy: property,
        districtOrder: orderTemp,
      });
      setOrder(orderTemp);
      getUsers(
        urlParam.superPage,
        urlParam.superLimit,
        urlParam.superQuery,
        urlParam.superOrderBy,
        urlParam.superOrder,
        urlParam.districtPage,
        urlParam.districtLimit,
        urlParam.districtQuery,
        property,
        orderTemp,
        urlParam.teacherPage,
        urlParam.teacherLimit,
        urlParam.teacherQuery,
        urlParam.teacherOrderBy,
        urlParam.teacherOrder,
        urlParam.delTeacherPage,
        urlParam.delTeacherLimit,
        urlParam.delTeacherQuery,
        urlParam.delTeacherOrderBy,
        urlParam.delTeacherOrder
      );
      history.replace({
        pathname: "/users",
        search: `?spage=${urlParam.superPage}&slimit=${urlParam.superLimit}&squery=${urlParam.superQuery}&sorderBy=${property}&sorder=${orderTemp}&dpage=${urlParam.districtPage}&dlimit=${urlParam.districtLimit}&dquery=${urlParam.districtQuery}&dorderBy=${urlParam.districtOrderBy}&dorder=${urlParam.districtOrderBy}&tpage=${urlParam.teacherPage}&tlimit=${urlParam.teacherLimit}&torderBy=${urlParam.teacherOrderBy}&torder=${urlParam.teacherOrder}&delTquery=${urlParam.delTeacherQuery}&delTpage=${urlParam.delTeacherPage}&delTlimit=${urlParam.delTeacherLimit}&delTquery=${urlParam.delTeacherQuery}&delTorderBy=${urlParam.delTeacherOrderBy}&delTorder=${urlParam.delTeacherOrder}&current=${currentUser}`,
      });
    } else {
      if (teacherSubTab) {
        setUrlParam({
          ...urlParam,
          teacherOrderBy: property,
          teacherOrder: orderTemp,
        });
        setOrder(orderTemp);
        getUsers(
          urlParam.superPage,
          urlParam.superLimit,
          urlParam.superQuery,
          urlParam.superOrderBy,
          urlParam.superOrder,
          urlParam.districtPage,
          urlParam.districtLimit,
          urlParam.districtQuery,
          urlParam.districtOrderBy,
          urlParam.districtOrder,
          urlParam.teacherPage,
          urlParam.teacherLimit,
          urlParam.teacherQuery,
          urlParam.teacherOrderBy,
          urlParam.teacherOrderBy,
          urlParam.delTeacherPage,
          urlParam.delTeacherLimit,
          urlParam.delTeacherQuery,
          property,
          orderTemp
        );
        history.replace({
          pathname: "/users",
          search: `?spage=${urlParam.superPage}&slimit=${urlParam.superLimit}&squery=${urlParam.superQuery}&sorderBy=${urlParam.superOrderBy}&sorder=${urlParam.superOrder}&dpage=${urlParam.districtPage}&dlimit=${urlParam.districtLimit}&dquery=${urlParam.districtQuery}&dorderBy=${urlParam.districtOrderBy}&dorder=${urlParam.districtOrder}&tpage=${urlParam.teacherPage}&tlimit=${urlParam.teacherLimit}&torderBy=${property}&torder=${orderTemp}&delTquery=${urlParam.delTeacherQuery}&delTpage=${urlParam.delTeacherPage}&delTlimit=${urlParam.delTeacherLimit}&delTquery=${urlParam.delTeacherQuery}&delTorderBy=${property}&delTorder=${orderTemp}&current=${currentUser}`,
        });
      } else {
        setUrlParam({
          ...urlParam,
          delTeacherOrderBy: property,
          delTeacherOrder: orderTemp,
        });
        setOrder(orderTemp);
        getUsers(
          urlParam.superPage,
          urlParam.superLimit,
          urlParam.superQuery,
          urlParam.superOrderBy,
          urlParam.superOrder,
          urlParam.districtPage,
          urlParam.districtLimit,
          urlParam.districtQuery,
          urlParam.districtOrderBy,
          urlParam.districtOrder,
          urlParam.teacherPage,
          urlParam.teacherLimit,
          urlParam.teacherQuery,
          property,
          orderTemp,
          urlParam.delTeacherPage,
          urlParam.delTeacherLimit,
          urlParam.delTeacherQuery,
          urlParam.delTeacherOrderBy,
          urlParam.delTeacherOrder
        );
        history.replace({
          pathname: "/users",
          search: `?spage=${urlParam.superPage}&slimit=${urlParam.superLimit}&squery=${urlParam.superQuery}&sorderBy=${urlParam.superOrder}&sorder=${urlParam.superOrder}&dpage=${urlParam.districtPage}&dlimit=${urlParam.districtLimit}&dquery=${urlParam.districtQuery}&dorderBy=${urlParam.districtOrderBy}&dorder=${urlParam.districtOrder}&tpage=${urlParam.teacherPage}&tlimit=${urlParam.teacherLimit}&torderBy=${property}&torder=${orderTemp}&delTquery=${urlParam.delTeacherQuery}&delTpage=${urlParam.delTeacherPage}&delTlimit=${urlParam.delTeacherLimit}&delTquery=${urlParam.delTeacherQuery}&delTorderBy=${property}&delTorder=${orderTemp}&current=${currentUser}`,
        });
      }
    }
  };
  const handleSelectAllClick = (event) => {
    if (event?.target?.checked) {
      return;
    }
    setSelected([]);
  };
  const handleChangeSchool = (event) => {
    setSelectSchoolId(event.target.value);
  };

  const getSchools = async (districtId) => {
    let res = await GetEverySchoolByDistrict(districtId, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      setAllSchools(res.res.data.data.schools);
      if (res.res.data.data.schools.length == 0) {
        setSnackBarShow(true);
        setSnackBarSeverity("error");
        setSnackBarMessage(
          "Sorry this District doesnt have any class added yet.Select Another District"
        );
        setSelectDistrictId("");
      }
    }
  };

  const editUser = (type, user) => {
    if (type == "admin") {
      setAdmin({
        fName: user.fName,
        lName: user.lName,
        email: user.email,
      });
    } else if (type == "district") {
      setDistrict({
        fName: user.fName,
        lName: user.lName,
        email: user.email,
        mobile: user.mobile,
      });
    } else {
      setTeacher({
        fName: user.fName,
        lName: user.lName,
        email: user.email,
      });
    }
  };

  const addUser = (type) => {
    if (currentUser == "admin") {
      setAdmin({
        fName: "",
        lName: "",
        email: "",
        password: "",
      });
    } else if (currentUser == "district") {
      setDistrict({
        fName: "",
        lName: "",
        email: "",
        password: "",
        mobile: "",
      });
    } else {
      setTeacher({
        fName: "",
        lName: "",
        email: "",
        password: "",
      });
    }
  };
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - superAdmins.length) : 0;
  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["KT_app"];
      setmyUser(user);
      let surlPage = parseInt(params.get("spage")) || 0;
      let surlLimit = parseInt(params.get("slimit")) || 25;
      let surlQuery = params.get("squery") || "";
      let durlPage = parseInt(params.get("dpage")) || 0;
      let durlLimit = parseInt(params.get("dlimit")) || 25;
      let durlQuery = params.get("dquery") || "";
      let turlPage = parseInt(params.get("tpage")) || 0;
      let turlLimit = parseInt(params.get("tlimit")) || 25;
      let turlQuery = params.get("tquery") || "";
      let delTurlPage = parseInt(params.get("delTpage")) || 0;
      let delTurlLimit = parseInt(params.get("delTlimit")) || 25;
      let delTurlQuery = params.get("delTquery") || "";
      let urlCurrent = params.get("current") || "admin";
      setUrlParam({
        superPage: surlPage,
        superLimit: surlLimit,
        superQuery: surlQuery,
        superOrderBy: urlParam.superOrderBy,
        superOrder: urlParam.superOrder,
        districtPage: durlPage,
        districtLimit: durlLimit,
        districtQuery: durlQuery,
        districtOrderBy: urlParam.districtOrderBy,
        districtOrder: urlParam.districtOrder,
        teacherPage: turlPage,
        teacherLimit: turlLimit,
        teacherQuery: turlQuery,
        teacherOrderBy: urlParam.teacherOrderBy,
        teacherOrder: urlParam.teacherOrder,
        delTeacherPage: delTurlPage,
        delTeacherLimit: delTurlLimit,
        delTeacherQuery: delTurlQuery,
        delTeacherOrderBy: urlParam.delTeacherOrderBy,
        delTeacherOrder: urlParam.delTeacherOrder,
      });
      setCurrentUser(urlCurrent);
      setValue(urlCurrent == "admin" ? 0 : urlCurrent == "district" ? 1 : 2);
      history.replace({
        pathname: "/users",
        search: `?spage=${surlPage}&slimit=${surlLimit}&squery=${surlQuery}&sorderBy=${urlParam.superOrderBy}&sorder=${urlParam.superOrder}&dpage=${durlPage}&dlimit=${durlLimit}&dquery=${durlQuery}&dorderBy=${urlParam.districtOrderBy}&dorder=${urlParam.districtOrder}&tpage=${turlPage}&tlimit=${turlLimit}&tquery=${turlQuery}&torderBy=${urlParam.teacherOrderBy}&torder=${urlParam.teacherOrder}&delTpage=${delTurlPage}&delTlimit=${delTurlLimit}&delTquery=${delTurlQuery}&delTorderBy=${urlParam.delTeacherOrderBy}&delTorder=${urlParam.delTeacherOrderBy}&current=${urlCurrent}`,
      });
      getUsers(
        surlPage,
        surlLimit,
        urlParam.superQuery,
        urlParam.superOrderBy,
        urlParam.superOrder,
        durlPage,
        durlLimit,
        urlParam.districtQuery,
        urlParam.districtOrderBy,
        urlParam.districtOrder,
        turlPage,
        turlLimit,
        urlParam.teacherQuery,
        urlParam.teacherOrderBy,
        urlParam.teacherOrder,
        delTurlPage,
        delTurlLimit,
        urlParam.delTeacherQuery,
        urlParam.delTeacherOrderBy,
        urlParam.delTeacherOrder,
        user
      );
    }
  }, []);

  const getUsers = async (
    spage,
    slimit,
    squery,
    sorderBy,
    sorder,
    dpage,
    dlimit,
    dquery,
    dorderBy,
    dorder,
    tpage,
    tlimit,
    tquery,
    torderBy,
    torder,
    delTpage,
    delTlimit,
    delTquery,
    delTorderBy,
    delTorder,
    user = myUser
  ) => {
    let res = await getUsersAdmin(
      user?.token,
      spage,
      slimit,
      squery,
      sorderBy,
      sorder,
      dpage,
      dlimit,
      dquery,
      dorderBy,
      dorder,
      tpage,
      tlimit,
      tquery,
      torderBy,
      torder,
      delTpage,
      delTlimit,
      delTquery,
      delTorderBy,
      delTorder
    );
    
    if (res.error) {
      // alert("Couldnt fetch School Districts. Try Again");
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      setAllDistrict(res.res.data.data.districts);
      setAllUsers(res.res.data.data.user);
      setSuperAdmins(res.res.data.data.superAdmin);
      setTeachers(res.res.data.data.teacher);
      setDeletedTeachers(res.res.data.data.deletedTeachers);
      setDistrictAdmins(res.res.data.data.districtAdmin);
      let divisor = parseInt(res.res.data.data.supercount / slimit);
      let remainder = res.res.data.data.supercount % slimit == 0 ? 0 : 1;
      //   setNoOfPages({...noOfPages,snoOfPages:(divisor+remainder)})
      setSNoOfPages(divisor + remainder);
      divisor = parseInt(res.res.data.data.districtcount / dlimit);
      remainder = res.res.data.data.districtcount % dlimit == 0 ? 0 : 1;
      //   setNoOfPages({...noOfPages,dnoOfPages:(divisor+remainder)})
      setDNoOfPages(divisor + remainder);
      divisor = parseInt(res.res.data.data.teachercount / tlimit);
      remainder = res.res.data.data.teachercount % tlimit == 0 ? 0 : 1;
      //   setNoOfPages({...noOfPages,tnoOfPages:(divisor+remainder)});
      setTNoOfPages(divisor + remainder);
      divisor = parseInt(res.res.data.data.deletedTeachercount / delTlimit);
      remainder =
        res.res.data.data.deletedTeachercount % delTlimit == 0 ? 0 : 1;
      //   setNoOfPages({...noOfPages,tnoOfPages:(divisor+remainder)});
      setDelTNoOfPages(divisor + remainder);
      setCurrPage({
        scurrPage: spage,
        dcurrPage: dpage,
        tcurrPage: tpage,
        delTcurrPage: delTpage,
      });
    }
  };

  const handleClose1 = () => {
    setPasswordState(false);
  };

  const ValidationForm = (type) => {
    if (currentUser == "teacher") {
      if (type == "add") {
        if (
          teacher.fName.trim() == "" ||
          teacher.fName == null ||
          teacher.lName.trim() == "" ||
          teacher.lName == null ||
          teacher.email.trim() == "" ||
          teacher.email == null ||
          !emailRegex.test(teacher.email) ||
          teacher.password.trim() == "" ||
          teacher.password == null ||
          teacher.password.length < 7 ||
          selectDistrictId.length < 1 ||
          selectSchoolId.length < 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          teacher.fName.trim() == "" ||
          teacher.fName == null ||
          teacher.lName.trim() == "" ||
          teacher.lName == null ||
          teacher.email.trim() == "" ||
          teacher.email == null ||
          !emailRegex.test(teacher.email)
        ) {
          return true;
        } else {
          return false;
        }
      }
    } else if (currentUser == "district") {
      if (type == "add") {
        if (
          district.fName.trim() == "" ||
          district.fName == null ||
          district.lName.trim() == "" ||
          district.lName == null ||
          district.email.trim() == "" ||
          district.email == null ||
          !emailRegex.test(district.email) ||
          district.password.trim() == "" ||
          district.password == null ||
          district.password.length < 7 ||
          district.mobile.trim() == "" ||
          district.mobile == null ||
          district.mobile.length < 5 ||
          district.mobile.length > 17 ||
          selectDistrictId.length < 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          district.fName.trim() == "" ||
          district.fName == null ||
          district.lName.trim() == "" ||
          district.lName == null ||
          district.email.trim() == "" ||
          district.email == null ||
          !emailRegex.test(district.email) ||
          district.mobile.trim() == "" ||
          district.mobile == null ||
          district.mobile.length > 17 ||
          district.mobile.length < 5
        ) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if (type == "add") {
        if (
          admin.fName.trim() == "" ||
          admin.fName == null ||
          admin.lName.trim() == "" ||
          admin.lName == null ||
          admin.email.trim() == "" ||
          admin.email == null ||
          !emailRegex.test(admin.email) ||
          admin.password.trim() == "" ||
          admin.password == null ||
          admin.password.length < 7
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          admin.fName.trim() == "" ||
          admin.fName == null ||
          admin.lName.trim() == "" ||
          admin.lName == null ||
          admin.email.trim() == "" ||
          admin.email == null ||
          !emailRegex.test(admin.email)
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const add_edit_delete_admin = async () => {
    let res;
    if (modified.add) {
      res = await SignupAdmin(admin, myUser.token);
    } else if (modified.edit) {
      res = await EditAdmin(admin, adminId, myUser.token);
    } else {
      res = await DeleteAdmin(adminId, myUser.token);
    }

    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      feedBackMsg(true, "success", res.res.data.msg);
      getUsers(
        urlParam.superPage,
        urlParam.superLimit,
        urlParam.superQuery,
        "createdAt",
        "desc",
        urlParam.districtPage,
        urlParam.districtLimit,
        urlParam.districtQuery,
        urlParam.districtOrderBy,
        urlParam.districtOrder,
        urlParam.teacherPage,
        urlParam.teacherLimit,
        urlParam.teacherQuery,
        urlParam.teacherOrderBy,
        urlParam.teacherOrder,
        urlParam.delTeacherPage,
        urlParam.delTeacherLimit,
        urlParam.delTeacherQuery,
        urlParam.delTeacherOrderBy,
        urlParam.delTeacherOrder
      );
      setAdmin({
        fName: "",
        lName: "",
        email: "",
        password: "",
      });
    }
    handleClose();
    handleClose2();
  };

  const add_edit_delete_District = async () => {
    let res;
    let sameMobile = false;
    if (modified.add) {
      res = await createDistrictAdminManually(
        selectDistrictId,
        district,
        myUser.token
      );
    } else if (modified.edit) {
      if (district.mobile.trim() == districtAdminMobile.trim()) {
        sameMobile = true;
      }
      res = await editSchoolDistrictsAdmin(
        selectDistrictId,
        districtAdminId,
        { ...district, sameMobile: sameMobile },
        myUser.token
      );
    } else {
      res = await deleteSchoolDistrictsAdmin(
        selectDistrictId,
        districtAdminId,
        myUser.token
      );
    }

    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      feedBackMsg(true, "success", res.res.data.msg);
      getUsers(
        urlParam.superPage,
        urlParam.superLimit,
        urlParam.superQuery,
        urlParam.superOrderBy,
        urlParam.superOrder,
        urlParam.districtPage,
        urlParam.districtLimit,
        urlParam.districtQuery,
        "createdAt",
        "desc",
        urlParam.teacherPage,
        urlParam.teacherLimit,
        urlParam.teacherQuery,
        urlParam.teacherOrderBy,
        urlParam.teacherOrder,
        urlParam.delTeacherPage,
        urlParam.delTeacherLimit,
        urlParam.delTeacherQuery,
        urlParam.delTeacherOrderBy,
        urlParam.delTeacherOrder
      );
      setDistrict({
        fName: "",
        lName: "",
        email: "",
        password: "",
        mobile: "",
      });
    }
    handleClose();
    handleClose2();
  };

  const add_edit_delete_Teacher = async () => {
    let res;
    if (modified.add) {
      res = await createFullNewTeacher(
        selectDistrictId,
        selectSchoolId,
        teacher,
        myUser.token
      );
    } else if (modified.edit) {
      res = await editTeacherDetails(
        { did: selectDistrictId, sid: selectSchoolId, teacherid: teacherId },
        teacher,
        myUser.token
      );
    } else {
      res = await deleteTeacherDetails(
        { did: selectDistrictId, sid: selectSchoolId, teacherid: teacherId },
        myUser.token
      );
    }

    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      feedBackMsg(true, "success", res.res.data.msg);
      getUsers(
        urlParam.superPage,
        urlParam.superLimit,
        urlParam.superQuery,
        urlParam.superOrderBy,
        urlParam.superOrder,
        urlParam.districtPage,
        urlParam.districtLimit,
        urlParam.districtQuery,
        urlParam.districtOrderBy,
        urlParam.districtOrder,
        urlParam.teacherPage,
        urlParam.teacherLimit,
        urlParam.teacherQuery,
        "createdAt",
        "desc",
        urlParam.delTeacherPage,
        urlParam.delTeacherLimit,
        urlParam.delTeacherQuery,
        urlParam.delTeacherOrderBy,
        urlParam.delTeacherOrder
      );
      setTeacher({
        fName: "",
        lName: "",
        email: "",
        password: "",
      });
    }
    handleClose();
    handleClose2();
  };

  const handleChangePage = (event, newPage) => {
    let surlPage = parseInt(params.get("spage")) || 0;
    let surlLimit = parseInt(params.get("slimit")) || 25;
    let surlQuery = params.get("squery") || "";
    let surlOrderBy = params.get("sorderBy") || "createdAt";
    let surlOrder = params.get("sorder") || "desc";
    let durlPage = parseInt(params.get("dpage")) || 0;
    let durlLimit = parseInt(params.get("dlimit")) || 25;
    let durlQuery = params.get("dquery") || "";
    let durlOrderBy = params.get("dorderBy") || "createdAt";
    let durlOrder = params.get("dorder") || "desc";
    let turlPage = parseInt(params.get("tpage")) || 0;
    let turlLimit = parseInt(params.get("tlimit")) || 25;
    let turlQuery = params.get("tquery") || "";
    let turlOrderBy = params.get("torderBy") || "createdAt";
    let turlOrder = params.get("torder") || "desc";
    let delTurlPage = parseInt(params.get("delTpage")) || 0;
    let delTurlLimit = parseInt(params.get("delTlimit")) || 25;
    let delTurlQuery = params.get("delTquery") || "";
    let delTurlOrderBy = params.get("delTorderBy") || "createdAt";
    let delTurlOrder = params.get("delTorder") || "desc";
    if (currentUser == "admin") {
      setUrlParam({ ...urlParam, superPage: event.selected });
      getUsers(
        event.selected,
        surlLimit,
        surlQuery,
        surlOrderBy,
        surlOrder,
        durlPage,
        durlLimit,
        durlQuery,
        durlOrderBy,
        durlOrder,
        turlPage,
        turlLimit,
        turlQuery,
        turlOrderBy,
        turlOrder,
        delTurlPage,
        delTurlLimit,
        delTurlQuery,
        delTurlOrderBy,
        delTurlOrder
      );
      history.replace({
        pathname: "/users",
        search: `?spage=${event.selected}&slimit=${urlParam.superLimit}&squery=${surlQuery}&sorderBy=${surlOrderBy}&sorder=${surlOrder}&dpage=${durlPage}&dlimit=${durlLimit}&dquery=${durlQuery}&dorderBy=${durlOrderBy}&dorder=${durlOrder}&tpage=${turlPage}&tlimit=${turlLimit}&tquery=${turlQuery}&torderBy=${turlOrderBy}&torder=${turlOrder}&delTpage=${delTurlPage}&delTlimit=${delTurlLimit}&delTquery=${delTurlQuery}&delTorderBy=${delTurlOrderBy}&delTorder=${delTurlOrder}&current=${currentUser}`,
      });
    } else if (currentUser == "district") {
      setUrlParam({ ...urlParam, districtPage: event.selected });
      getUsers(
        surlPage,
        surlLimit,
        surlQuery,
        surlOrderBy,
        surlOrder,
        event.selected,
        durlLimit,
        durlQuery,
        durlOrderBy,
        durlOrder,
        turlPage,
        turlLimit,
        turlQuery,
        turlOrderBy,
        turlOrder,
        delTurlPage,
        delTurlLimit,
        delTurlQuery,
        delTurlOrderBy,
        delTurlOrder
      );
      history.replace({
        pathname: "/users",
        search: `?spage=${surlPage}&slimit=${urlParam.superLimit}&squery=${surlQuery}&sorderBy=${surlOrderBy}&sorder=${surlOrder}&dpage=${event.selected}&dlimit=${durlLimit}&dquery=${durlQuery}&dorderBy=${durlOrderBy}&dorder=${durlOrder}&tpage=${turlPage}&tlimit=${turlLimit}&tquery=${turlQuery}&torder=${turlOrder}&torderBy=${turlOrderBy}&delTpage=${delTurlPage}&delTlimit=${delTurlLimit}&delTquery=${delTurlQuery}&delTorderBy=${delTurlOrderBy}&delTorder=${delTurlOrder}&current=${currentUser}`,
      });
    } else {
      if (teacherSubTab) {
        setUrlParam({ ...urlParam, delTeacherPage: event.selected });
        getUsers(
          surlPage,
          surlLimit,
          surlQuery,
          surlOrderBy,
          surlOrder,
          durlPage,
          durlLimit,
          durlQuery,
          durlOrderBy,
          durlOrder,
          turlPage,
          turlLimit,
          turlOrderBy,
          turlQuery,
          turlOrder,
          event.selected,
          delTurlLimit,
          delTurlQuery,
          delTurlOrderBy,
          delTurlOrder
        );
        history.replace({
          pathname: "/users",
          search: `?spage=${surlPage}&slimit=${urlParam.superLimit}&squery=${surlQuery}&sorderBy=${surlOrderBy}&sorder=${surlOrder}&dpage=${durlPage}&dlimit=${durlLimit}&dquery=${durlQuery}&dorderBy=${durlOrderBy}&dorder=${durlOrder}&tpage=${turlPage}&tlimit=${turlLimit}&tquery=${turlQuery}&torder=${turlOrder}&torderBy=${turlOrderBy}&delTpage=${event.selected}&delTlimit=${delTurlLimit}&delTquery=${delTurlQuery}&delTorderBy=${delTurlOrderBy}&delTorder=${delTurlOrder}&current=${currentUser}`,
        });
      } else {
        setUrlParam({ ...urlParam, teacherPage: event.selected });
        getUsers(
          surlPage,
          surlLimit,
          surlQuery,
          surlOrderBy,
          surlOrder,
          durlPage,
          durlLimit,
          durlQuery,
          durlOrderBy,
          durlOrder,
          event.selected,
          turlLimit,
          turlQuery,
          turlOrderBy,
          turlOrder,
          delTurlPage,
          delTurlLimit,
          delTurlQuery,
          delTurlOrderBy,
          delTurlOrder
        );
        history.replace({
          pathname: "/users",
          search: `?spage=${surlPage}&slimit=${surlLimit}&squery=${surlQuery}&sorderBy=${surlOrderBy}&sorder=${surlOrder}&dpage=${durlPage}&dlimit=${durlLimit}&dquery=${durlQuery}&dorderBy=${durlOrderBy}&dorder=${durlOrder}&tpage=${event.selected}&tlimit=${turlLimit}&tquery=${turlQuery}&torderBy=${turlOrderBy}&torder=${turlOrder}&delTpage=${delTurlPage}&delTlimit=${delTurlLimit}&delTquery=${delTurlQuery}&delTorderBy=${delTurlOrderBy}&delTorder=${delTurlOrder}&current=${currentUser}`,
        });
      }
    }
  };

  const passwordChange = async (user) => {
    let res, ids, data;
    if (user == "admin") {
      data = { email: admin.email, password: password };
      res = await passwordChangeSuperAdmin(adminId, data, myUser.token);
    } else if (user == "district") {
      ids = { did: selectDistrictId, sdid: districtAdminId };
      data = { email: district.email, password: password };
      res = await passwordChangeDistrictAdmin(ids, data, myUser.token);
    } else {
      ids = {
        did: selectDistrictId,
        sid: selectSchoolId,
        teacherid: teacherId,
      };
      data = { email: teacher.email, password: password };
      res = await passwordChangeTeacher(ids, data, myUser.token);
    }

    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      feedBackMsg(true, "success", res.res.data.msg);
    }
    handleClose1();
    handleClose2();
  };

  const handleClose = () => {
    setOpen(false);
    setModified({
      add: false,
      edit: false,
      delete: false,
    });
    setAdminTouched({
      fName: false,
      lName: false,
      email: false,
      password: false,
    });
    setTeacherTouched({
      fName: false,
      lName: false,
      email: false,
      password: false,
    });
    setDistrictTouched({
      fName: false,
      lName: false,
      email: false,
      password: false,
      mobile: false,
    });
    setSelectDistrictId("");
    setSelectSchoolId("");
  };

  const handleClose2 = () => {
    setShowInfo(false);
  };
  return (
    <section id="hero-school ">
      <div>
        <NavBar />
        <br />
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Super Admin" {...a11yProps(0)} />
              <Tab label="District/School Admin" {...a11yProps(1)} />
              <Tab label="Teacher" {...a11yProps(2)} />
            </Tabs>
          </Box>
          {/* Render sub-tabs when the "Teacher" tab is selected */}
          {value === 2 && (
            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}>
              <Tabs
                value={teacherSubTab}
                onChange={handleTeacherSubTabChange}
                aria-label="teacher sub-tabs"
              >
                <Tab label="Teachers" {...a11yProps(0)} />
                <Tab label="Deleted Teachers" {...a11yProps(1)} />
              </Tabs>
            </Box>
          )}
          <TabPanel value={value} index={0} user={"admin"}>
            {/* <UserTable data={superAdmins}/> */}
            <div className="d-flex justify-content-end align-items-end">
              <ReactPaginate
                previousLabel="Previous"
                nextLabel="Next"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={snoOfPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handleChangePage}
                containerClassName="pagination"
                activeClassName="activePage active"
                forcePage={currPage.scurrPage}
              />
            </div>
            <div className="col-lg-8 col-md-7 col-sm-12">
              <TextField
                sx={{ minWidth: 250, width: 600, background: "white" }}
                value={urlParam.superQuery}
                id="outlined-search"
                label="Search"
                type="search"
                onChange={(e) => {
                  setUrlParam({
                    ...urlParam,
                    superQuery: e.target.value,
                    superPage: 0,
                  });
                  getUsers(
                    0,
                    urlParam.superLimit,
                    e.target.value,
                    urlParam.superOrderBy,
                    urlParam.superOrder,
                    urlParam.districtPage,
                    urlParam.districtLimit,
                    urlParam.districtQuery,
                    urlParam.districtOrderBy,
                    urlParam.districtOrder,
                    urlParam.teacherPage,
                    urlParam.teacherLimit,
                    urlParam.teacherQuery,
                    urlParam.teacherOrderBy,
                    urlParam.teacherOrder,
                    urlParam.delTeacherPage,
                    urlParam.delTeacherLimit,
                    urlParam.delTeacherQuery,
                    urlParam.delTeacherOrderBy,
                    urlParam.delTeacherOrder
                  );
                }}
              />
            </div>
            <div className="d-flex justify-content-end align-items-end">
              <button
                className="btn btn-add float-right"
                onClick={() => {
                  setModified({ ...modified, add: true });
                  setOpen(true);
                  addUser("admin");
                }}
              >
                <i className="fas fa-plus-circle"></i> {"  "}
                <span>Add Super Admin</span>
              </button>
            </div>
            {/* ADMIN TABLE */}
            <Box sx={{ width: "100%" }}>
              <Paper sx={{ width: "100%", my: 2 }}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer sx={{ height: "80vh", overflow: "auto" }}>
                  <Table
                    sx={{ minWidth: 750}}
                    aria-labelledby="tableTitle"
                    size={"small"}
                    stickyHeader
                    className="table"
                  >
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={onSetOrder}
                      rowCount={superAdmins?.length}
                    />
                    <TableBody>
                      {superAdmins.map((data, index) => (
                        <TableRow
                          key={index}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          className="cursorBody"
                          onClick={() => info(data, "admin")}
                        >
                          <TableCell
                            align="center"
                            className="text-truncate"
                            style={{ maxWidth: "150px" }}
                          >
                            {"Super Admin"}
                          </TableCell>
                          {/* <TableCell align="center">--</TableCell> */}
                          <TableCell align="center">
                            {data.fName} {data.lName}
                          </TableCell>
                          <TableCell align="right">{data?.email}</TableCell>
                          <TableCell align="right">
                            {new Date(data.createdAt).toLocaleDateString()}{" "}
                            {new Date(data.createdAt).toLocaleTimeString()}
                          </TableCell>
                        </TableRow>
                      ))}

                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: (dense ? 33 : 53) * emptyRows,
                          }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <Snackbar
                open={snackBarShow}
                autoHideDuration={3000}
                onClose={SnackClose}
              >
                <Alert
                  onClose={SnackClose}
                  severity={snackBarSeverity}
                  sx={{ width: "100%" }}
                >
                  {snackBarMessage}
                </Alert>
              </Snackbar>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1} user={"district"}>
            {/* <UserTable data={districtAdmins} /> */}
            <div className="d-flex justify-content-end align-items-end">
              <ReactPaginate
                previousLabel="Previous"
                nextLabel="Next"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={dnoOfPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handleChangePage}
                containerClassName="pagination"
                activeClassName="activePage active"
                forcePage={currPage.dcurrPage}
              />
            </div>
            <div className="col-lg-8 col-md-7 col-sm-12">
              <TextField
                sx={{ minWidth: 250, width: 600, background: "white" }}
                value={urlParam.districtQuery}
                id="outlined-search"
                label="Search"
                type="search"
                onBlur={(e) => {
                  setUrlParam({
                    ...urlParam,
                    districtQuery: e.target.value.trim(),
                  });
                }}
                onChange={(e) => {
                  setUrlParam({
                    ...urlParam,
                    districtQuery: e.target.value,
                    districtPage: 0,
                  });
                  getUsers(
                    urlParam.superPage,
                    urlParam.superLimit,
                    urlParam.superQuery,
                    urlParam.superOrderBy,
                    urlParam.superOrder,
                    0,
                    urlParam.districtLimit,
                    e.target.value,
                    urlParam.districtOrderBy,
                    urlParam.districtOrder,
                    urlParam.teacherPage,
                    urlParam.teacherLimit,
                    urlParam.teacherQuery,
                    urlParam.teacherOrderBy,
                    urlParam.teacherOrder,
                    urlParam.delTeacherPage,
                    urlParam.delTeacherLimit,
                    urlParam.delTeacherQuery,
                    urlParam.delTeacherOrderBy,
                    urlParam.delTeacherOrder
                  );
                }}
              />
            </div>
            <div className="d-flex justify-content-end align-items-end">
              <button
                className="btn btn-add float-right"
                onClick={() => {
                  setModified({ ...modified, add: true });
                  setOpen(true);
                  addUser("district");
                }}
              >
                <i className="fas fa-plus-circle"></i> {"  "}
                <span>Add District/School Admin</span>
              </button>
            </div>
            {/* District TABLE */}
            <Box sx={{ width: "100%" }}>
              <Paper sx={{ width: "100%", my: 2 }}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer sx={{ height: "80vh", overflow: "auto" }}>
                  <Table
                    sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size={"small"}
                    stickyHeader
                    className="table"
                  >
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={onSetOrder}
                      rowCount={districtAdmins?.length}
                    />
                    <TableBody>
                      {districtAdmins.map((data, index) => (
                        <TableRow
                          key={index}
                          hover
                          role="checkbox"
                          className="cursorBody"
                          tabIndex={-1}
                          onClick={() => info(data, "district")}
                        >
                          <TableCell
                            align="center"
                            className="text-truncate"
                            style={{ maxWidth: "150px" }}
                          >
                            {data.type == "individual"
                              ? "School Admin"
                              : "District Admin"}
                          </TableCell>
                          {/* <TableCell align="center">--</TableCell> */}
                          <TableCell align="center">
                            {data.fName} {data.lName}
                          </TableCell>
                          <TableCell align="right">{data?.email}</TableCell>
                          <TableCell align="right">
                            {new Date(data.createdAt).toLocaleDateString()}{" "}
                            {new Date(data.createdAt).toLocaleTimeString()}
                          </TableCell>
                        </TableRow>
                      ))}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: (dense ? 33 : 53) * emptyRows,
                          }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <Snackbar
                open={snackBarShow}
                autoHideDuration={3000}
                onClose={SnackClose}
              >
                <Alert
                  onClose={SnackClose}
                  severity={snackBarSeverity}
                  sx={{ width: "100%" }}
                >
                  {snackBarMessage}
                </Alert>
              </Snackbar>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2} user={"teacher"}>
            {/* <UserTable data={teachers}/> */}
            <div className="d-flex justify-content-end align-items-end">
              <ReactPaginate
                previousLabel="Previous"
                nextLabel="Next"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={teacherSubTab ? delTnoOfPages : tnoOfPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handleChangePage}
                containerClassName="pagination"
                activeClassName="activePage active"
                forcePage={
                  teacherSubTab ? currPage.delTcurrPage : currPage.tcurrPage
                }
              />
            </div>
            <div className="col-lg-8 col-md-7 col-sm-12">
              <TextField
                sx={{ minWidth: 250, width: 600, background: "white" }}
                value={
                  teacherSubTab
                    ? urlParam.delTeacherQuery
                    : urlParam.teacherQuery
                }
                id="outlined-search"
                label="Search"
                type="search"
                onBlur={(e) =>
                  setUrlParam({
                    ...urlParam,
                    ...(teacherSubTab
                      ? { delTeacherQuery: e.target.value.trim() }
                      : { teacherQuery: e.target.value.trim() }),
                  })
                }
                onChange={(e) => {
                  setUrlParam({
                    ...urlParam,
                    ...(teacherSubTab
                      ? { delTeacherQuery: e.target.value, delTeacherPage: 0 }
                      : { teacherQuery: e.target.value, teacherPage: 0 }),
                  });
                  getUsers(
                    urlParam.superPage,
                    urlParam.superLimit,
                    urlParam.superQuery,
                    urlParam.superOrderBy,
                    urlParam.superOrder,
                    urlParam.districtPage,
                    urlParam.districtLimit,
                    urlParam.districtQuery,
                    urlParam.districtOrderBy,
                    urlParam.districtOrder,
                    !teacherSubTab ? 0 : urlParam.teacherPage,
                    urlParam.teacherLimit,
                    !teacherSubTab ? e.target.value : urlParam.teacherQuery,
                    urlParam.teacherOrderBy,
                    urlParam.teacherOrder,
                    teacherSubTab ? 0 : urlParam.delTeacherPage,
                    urlParam.teacherLimit,
                    teacherSubTab ? e.target.value : urlParam.delTeacherQuery,
                    urlParam.delTeacherOrderBy,
                    urlParam.delTeacherOrder
                  );
                }}
              />
            </div>
            {!teacherSubTab && (
              <div className="d-flex justify-content-end align-items-end">
                <button
                  className="btn btn-add float-right"
                  onClick={() => {
                    setModified({ ...modified, add: true });
                    setOpen(true);
                    addUser("teacher");
                  }}
                >
                  <i className="fas fa-plus-circle"></i> {"  "}
                  <span>Add Teacher</span>
                </button>
              </div>
            )}
            {/* TEACHER TABLE */}
            <Box sx={{ width: "100%" }}>
              <Paper sx={{ width: "100%", my: 2 }}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer sx={{ height: "80vh", overflow: "auto" }}>
                  <Table
                    sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size={"small"}
                    stickyHeader
                    className="table"
                  >
                    <EnhancedTeacherTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={onSetOrder}
                      rowCount={
                        teacherSubTab
                          ? deletedTeachers?.length
                          : teachers?.length
                      }
                    />
                    <TableBody>
                      {(teacherSubTab ? deletedTeachers : teachers).map(
                        (data, index) => {
                          return ( 
                            <TableRow
                              key={index}
                              hover
                              role="checkbox"
                              className="cursorBody"
                              tabIndex={-1}
                              onClick={() => info(data, "teacher")}
                            >
                              <TableCell
                                align="center"
                                className="text-truncate"
                                style={{ maxWidth: "150px" }}
                              >
                                {data.userType.charAt(0).toUpperCase() +
                                  data.userType.slice(1)}
                              </TableCell>
                              <TableCell align="center">
                                {data.fName} {data.lName}
                              </TableCell>
                              <TableCell align="right">{data?.email}</TableCell>
                              <TableCell className=" textCap">
                                {data?.schoolDistrict?.name}
                              </TableCell>{" "}
                              <TableCell className=" textCap">
                                {data?.school?.name}
                              </TableCell>{" "}
                              <TableCell align="right">
                                {new Date(data.createdAt).toLocaleDateString()}{" "}
                                {new Date(data.createdAt).toLocaleTimeString()}
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: (dense ? 33 : 53) * emptyRows,
                          }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <Snackbar
                open={snackBarShow}
                autoHideDuration={3000}
                onClose={SnackClose}
              >
                <Alert
                  onClose={SnackClose}
                  severity={snackBarSeverity}
                  sx={{ width: "100%" }}
                >
                  {snackBarMessage}
                </Alert>
              </Snackbar>
            </Box>
          </TabPanel>
        </Box>
      </div>
      <Snackbar
        open={snackBarShow}
        autoHideDuration={3000}
        onClose={SnackClose}
      >
        <Alert
          onClose={SnackClose}
          severity={snackBarSeverity}
          sx={{ width: "100%" }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>

      <Dialog open={showInfo} handleClose={handleClose2} fullWidth>
        <section id="hero-Msd">
          <DialogTitle>
            <Grid container justify="space-between" alignItems="center">
              <Typography variant="h6" style={{ fontWeight: "600" }}>
                {currentUser == "district"
                  ? `School District Admin Details`
                  : currentUser == "teacher"
                  ? `Teacher Details`
                  : currentUser == "admin"
                  ? `Super Admin Details`
                  : null}
              </Typography>
              <IconButton onClick={handleClose2}>
                <CloseIcon
                  style={{ border: "2px solid black", fontSize: "30px" }}
                />
              </IconButton>
            </Grid>
          </DialogTitle>

          <div className="container">
            <div className="row">
              <div className="col-4 h6">First Name</div>
              <div className="col-8 h5 textCap">
                {currentUser == "admin"
                  ? `${admin.fName}`
                  : currentUser == "district"
                  ? `${district.fName}`
                  : currentUser == "teacher"
                  ? `${teacher.fName}`
                  : null}
              </div>
              <br />
              <div className="col-4 h6">Last Name</div>
              <div className="col-8 h5 textCap">
                {currentUser == "admin"
                  ? `${admin.lName}`
                  : currentUser == "district"
                  ? `${district.lName}`
                  : currentUser == "teacher"
                  ? `${teacher.lName}`
                  : null}
              </div>
              <br />
              <div className="col-4 h6">Email</div>
              <div className="col-8 h5">
                {currentUser == "admin"
                  ? `${admin.email}`
                  : currentUser == "district"
                  ? `${district.email}`
                  : currentUser == "teacher"
                  ? `${teacher.deleted ? teacher.emailF : teacher.email}`
                  : null}
              </div>

              <br />
              {currentUser == "district" ? (
                <>
                  <div className="col-4 h6">Mobile</div>
                  <div className="col-8 h5">{district.mobile}</div>
                  <br />
                </>
              ) : null}
              {currentUser == "district" || currentUser == "teacher" ? (
                <>
                  <div className="col-4 h6">School District</div>
                  <div className="col-8 h5">{districtName}</div>
                  <br />
                </>
              ) : null}
              {currentUser == "teacher" ? (
                <>
                  <div className="col-4 h6">School</div>
                  <div className="col-8 h5">{schoolName}</div>
                  <br />
                </>
              ) : null}
              <div className="col-4 h6">{user?.deleted ? "" : "Actions"}</div>
              <div className="col-8 h5">
                {currentUser == "admin" ? (
                  <>
                    <Tooltip title="Edit" placement="top">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModified({ ...modified, edit: true });
                          editUser("admin", user);
                          setAdminId(user._id);
                          setOpen(true);
                          editUser("district", user);
                        }}
                      >
                        <i className="fas fa-edit icon-size-30"></i>
                      </span>
                    </Tooltip>
                    &nbsp;
                    <Tooltip title="Delete" placement="top">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModified({ ...modified, delete: true });
                          setOpen(true);
                          editUser("admin", user);
                          setAdminId(user._id);
                        }}
                      >
                        <i className="fas fa-trash-alt icon-size-30"></i>
                      </span>
                    </Tooltip>
                    {user._id == myUser.userId ? (
                      <>
                        &nbsp;
                        <Tooltip title="Mail Password" placement="top">
                          <Link
                            onClick={() => {
                              editUser("admin", user);
                              setAdminId(user._id);
                              setPasswordState(true);
                              setPassword("");
                            }}
                          >
                            <i className="fa fa-key icon-size-20"></i>
                          </Link>
                        </Tooltip>
                      </>
                    ) : null}
                  </>
                ) : currentUser == "district" ? (
                  <>
                    <Tooltip title="Edit" placement="top">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModified({ ...modified, edit: true });
                          setSelectDistrictId(user.schoolDistrict);
                          setOpen(true);
                          editUser("district", user);
                          setDistrictAdminId(user._id);
                          setDistrictAdminMobile(user.mobile);
                        }}
                      >
                        <i className="fas fa-edit icon-size-30"></i>
                      </span>
                    </Tooltip>
                    &nbsp;
                    <Tooltip title="Delete" placement="top">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModified({ ...modified, delete: true });
                          setSelectDistrictId(user.schoolDistrict);
                          setOpen(true);
                          editUser("district", user);
                          setDistrictAdminId(user._id);
                        }}
                      >
                        <i className="fas fa-trash-alt icon-size-30"></i>
                      </span>
                    </Tooltip>
                    &nbsp;
                    <Tooltip title="Mail Password" placement="top">
                      <Link
                        onClick={() => {
                          editUser("district", user);
                          setPassword("");
                          setPasswordState(true);
                          setPassword("");
                          setSelectDistrictId(user.schoolDistrict._id);
                          setDistrictAdminId(user._id);
                        }}
                      >
                        <i className="fa fa-key icon-size-20"></i>
                      </Link>
                    </Tooltip>
                  </>
                ) : currentUser == "teacher" && !user.deleted ? (
                  <>
                    <Tooltip title="Edit" placement="top">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModified({ ...modified, edit: true });
                          setSelectDistrictId(user?.schoolDistrict?._id);
                          setSelectSchoolId(user?.school?._id);
                          setOpen(true);
                          editUser("teacher", user);
                          setTeacherId(user._id);
                        }}
                      >
                        <i className="fas fa-edit icon-size-30"></i>
                      </span>
                    </Tooltip>
                    &nbsp;
                    <Tooltip title="Delete" placement="top">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModified({ ...modified, delete: true });
                          setSelectDistrictId(user?.schoolDistrict?._id);
                          setSelectSchoolId(user?.school?._id);
                          setOpen(true);
                          editUser("teacher", user);
                          setTeacherId(user._id);
                        }}
                      >
                        <i className="fas fa-trash-alt icon-size-30"></i>
                      </span>
                    </Tooltip>
                    &nbsp;
                    <Tooltip title="Change Password" placement="top">
                      <Link
                        onClick={() => {
                          editUser("teacher", user);
                          setPassword("");
                          setPasswordState(true);
                          setSelectDistrictId(user?.schoolDistrict?._id);
                          setSelectSchoolId(user?.school?._id);
                          setTeacherId(user._id);
                        }}
                      >
                        <i className="fa fa-key icon-size-20"></i>
                      </Link>
                    </Tooltip>
                  </>
                ) : null}
              </div>
              <br />
            </div>
          </div>
          <br />
        </section>
      </Dialog>

      <Dialog open={passwordState} handleClose={handleClose1} fullWidth>
        <section id="hero-Msd">
          <DialogTitle>
            <Grid container justify="space-between" alignItems="center">
              <Typography variant="h6" style={{ fontWeight: "600" }}>
                {currentUser == "district"
                  ? `Change Password for ${district.fName} ${district.lName}`
                  : currentUser == "teacher"
                  ? `Change Password for ${teacher.fName} ${teacher.lName}`
                  : currentUser == "admin"
                  ? `Change Password for ${admin.fName} ${admin.lName}`
                  : null}
              </Typography>
              <IconButton onClick={handleClose1}>
                <CloseIcon
                  style={{ border: "2px solid black", fontSize: "30px" }}
                />
              </IconButton>
            </Grid>
          </DialogTitle>
          <div className="col-md-9 text-left col-9 m-auto">
            {currentUser == "district" ? (
              <>
                <div className="form-group mt-4 p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={password}
                    placeholder="Password"
                    onBlur={(e) => setPassword(e.target.value.trim())}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span style={{ color: "red" }}>
                    Password should be atleast 8 characters
                  </span>
                </div>
              </>
            ) : currentUser == "teacher" ? (
              <>
                <div className="form-group mt-4 p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={password}
                    placeholder="Password"
                    onBlur={(e) => setPassword(e.target.value.trim())}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span style={{ color: "red" }}>
                    Password should be atleast 8 characters
                  </span>
                </div>
              </>
            ) : currentUser == "admin" ? (
              <>
                <div className="form-group mt-4 p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={password}
                    placeholder="Password"
                    onBlur={(e) => setPassword(e.target.value.trim())}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span style={{ color: "red" }}>
                    Password should be atleast 8 characters
                  </span>
                </div>
              </>
            ) : null}
          </div>
          <div className="col-md-9 text-left  col-9 m-auto">
            <div className="form-group p-20">
              <button
                type="button"
                className="cta-btn"
                disabled={password.trim().length > 7 ? false : true}
                onClick={() => {
                  passwordChange(
                    currentUser == "district"
                      ? "district"
                      : currentUser == "admin"
                      ? "admin"
                      : "teacher"
                  );
                }}
              >
                Change Password
              </button>
            </div>
          </div>
        </section>
      </Dialog>

      <Dialog handleClose={handleClose} open={open} fullWidth>
        <section id="hero-Msd">
          <DialogTitle>
            <Grid container justify="space-between" alignItems="center">
              <Typography variant="h6" style={{ fontWeight: "600" }}>
                {modified.add
                  ? `Add ${
                      currentUser == "admin"
                        ? "Super Admin"
                        : currentUser == "district"
                        ? "District/School Admin"
                        : "Teacher"
                    }`
                  : modified.edit
                  ? `Edit ${
                      currentUser == "admin"
                        ? "Super Admin"
                        : currentUser == "district"
                        ? "District/School Admin"
                        : "Teacher"
                    }`
                  : modified.delete
                  ? ` Delete ${
                      currentUser == "admin"
                        ? "Super Admin"
                        : currentUser == "district"
                        ? "District/School Admin"
                        : "Teacher"
                    }`
                  : null}
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon
                  style={{ border: "2px solid black", fontSize: "30px" }}
                />
              </IconButton>
            </Grid>
          </DialogTitle>

          {currentUser == "admin" && (modified.add || modified.edit) ? (
            <>
              <div className="col-md-9 text-left  col-9 m-auto">
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={admin.fName}
                    placeholder="First Name"
                    onChange={(e) =>
                      setAdmin({ ...admin, fName: e.target.value })
                    }
                    onBlur={(e) => {
                      setAdminTouched({ ...adminTouched, fName: true });
                      setAdmin({ ...admin, fName: e.target.value.trim() });
                    }}
                  />
                  {admin.fName.trim() == "" && adminTouched.fName ? (
                    <span style={{ color: "red" }}>FirstName is required</span>
                  ) : null}
                </div>
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={admin.lName}
                    placeholder="Last Name"
                    onChange={(e) =>
                      setAdmin({ ...admin, lName: e.target.value })
                    }
                    onBlur={(e) => {
                      setAdminTouched({ ...adminTouched, lName: true });
                      setAdmin({ ...admin, lName: e.target.value.trim() });
                    }}
                  />
                  {admin.lName.trim() == "" && adminTouched.lName ? (
                    <span style={{ color: "red" }}>LastName is required</span>
                  ) : null}
                </div>
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={admin.email}
                    placeholder="Email"
                    onPaste={(e) =>
                      setAdmin({ ...admin, email: e.target.value.trim() })
                    }
                    onChange={(e) =>
                      setAdmin({ ...admin, email: e.target.value })
                    }
                    onBlur={(e) => {
                      setAdminTouched({ ...adminTouched, email: true });
                      setAdmin({ ...admin, email: e.target.value.trim() });
                    }}
                  />
                  {admin.email.trim() == "" && adminTouched.email ? (
                    <span style={{ color: "red" }}>Email is required</span>
                  ) : !emailRegex.test(admin.email) &&
                    admin.email.trim() != "" &&
                    adminTouched.email ? (
                    <span style={{ color: "red" }}>
                      Email pattern is required
                    </span>
                  ) : null}
                </div>
                {modified.add ? (
                  <>
                    <div className="form-group mt-4   p-20">
                      <input
                        type="text"
                        className="form-control"
                        value={admin.password}
                        placeholder="Password"
                        onChange={(e) =>
                          setAdmin({ ...admin, password: e.target.value })
                        }
                        onBlur={(e) => {
                          setAdminTouched({ ...adminTouched, password: true });
                          setAdmin({
                            ...admin,
                            password: e.target.value.trim(),
                          });
                        }}
                      />
                      {admin.password.trim() == "" && adminTouched.password ? (
                        <span style={{ color: "red" }}>
                          Password is required
                        </span>
                      ) : null}
                      <br />
                      <small style={{ color: "red" }}>
                        Password should contain upto 8 characters
                      </small>
                    </div>
                  </>
                ) : null}
                <br />
              </div>
            </>
          ) : currentUser == "district" && (modified.add || modified.edit) ? (
            <>
              <div className="col-md-9 text-left  col-9 m-auto">
                {modified.add ? (
                  <>
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          District
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectDistrictId}
                          label="Districts"
                          // sx={{borderRadius:'23px'}}
                          onChange={handleChangeDistrict}
                        >
                          {allDistrict.map((item, index) => {
                            return (
                              <MenuItem value={item._id}>{item.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                  </>
                ) : null}
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={district.fName}
                    placeholder="First Name"
                    onChange={(e) =>
                      setDistrict({ ...district, fName: e.target.value })
                    }
                    onBlur={(e) => {
                      setDistrictTouched({ ...districtTouched, fName: true });
                      setDistrict({
                        ...district,
                        fName: e.target.value.trim(),
                      });
                    }}
                  />
                  {district.fName.trim() == "" && districtTouched.fName ? (
                    <span style={{ color: "red" }}>FirstName is required</span>
                  ) : null}
                </div>
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={district.lName}
                    placeholder="Last Name"
                    onChange={(e) =>
                      setDistrict({ ...district, lName: e.target.value })
                    }
                    onBlur={(e) => {
                      setDistrictTouched({ ...districtTouched, lName: true });
                      setDistrict({
                        ...district,
                        lName: e.target.value.trim(),
                      });
                    }}
                  />
                  {district.lName.trim() == "" && districtTouched.lName ? (
                    <span style={{ color: "red" }}>LastName is required</span>
                  ) : null}
                </div>
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={district.email}
                    placeholder="Email"
                    onPaste={(e) =>
                      setDistrict({ ...district, email: e.target.value.trim() })
                    }
                    onChange={(e) =>
                      setDistrict({ ...district, email: e.target.value })
                    }
                    onBlur={(e) => {
                      setDistrictTouched({ ...districtTouched, email: true });
                      setDistrict({
                        ...district,
                        email: e.target.value.trim(),
                      });
                    }}
                  />
                  {district.email.trim() == "" && districtTouched.email ? (
                    <span style={{ color: "red" }}>Email is required</span>
                  ) : !emailRegex.test(district.email) &&
                    district.email.trim() != "" &&
                    districtTouched.email ? (
                    <span style={{ color: "red" }}>
                      Email pattern is required
                    </span>
                  ) : null}
                </div>
                {modified.add ? (
                  <>
                    <div className="form-group mt-4   p-20">
                      <input
                        type="text"
                        className="form-control"
                        value={district.password}
                        placeholder="Password"
                        onChange={(e) =>
                          setDistrict({ ...district, password: e.target.value })
                        }
                        onBlur={(e) => {
                          setDistrictTouched({
                            ...districtTouched,
                            password: true,
                          });
                          setDistrict({
                            ...district,
                            password: e.target.value.trim(),
                          });
                        }}
                      />
                      {district.password.trim() == "" &&
                      districtTouched.password ? (
                        <span style={{ color: "red" }}>
                          Password is required
                        </span>
                      ) : null}
                      <br />
                      <small style={{ color: "red" }}>
                        Password should contain upto 8 characters
                      </small>
                    </div>
                  </>
                ) : null}
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    maxLength={16}
                    value={district.mobile}
                    placeholder="Mobile"
                    onChange={(e) =>
                      setDistrict({ ...district, mobile: e.target.value })
                    }
                    onBlur={(e) => {
                      setDistrictTouched({ ...districtTouched, mobile: true });
                      setDistrict({
                        ...district,
                        mobile: e.target.value.trim(),
                      });
                    }}
                  />
                  {district.mobile.trim() == "" && districtTouched.mobile ? (
                    <span style={{ color: "red" }}>Mobile is required</span>
                  ) : null}
                </div>
              </div>
            </>
          ) : currentUser == "teacher" && (modified.add || modified.edit) ? (
            <>
              <div className="col-md-9 text-left  col-9 m-auto">
                {modified.add ? (
                  <>
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          District
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectDistrictId}
                          label="Districts"
                          // sx={{borderRadius:'23px'}}
                          onChange={handleChangeDistrict}
                        >
                          {allDistrict.map((item, index) => {
                            return (
                              <MenuItem value={item._id}>{item.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                    {selectDistrictId != "" ? (
                      <>
                        <br />
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              School
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={selectSchoolId}
                              label="Districts"
                              // sx={{borderRadius:'23px'}}
                              onChange={handleChangeSchool}
                            >
                              {allSchools.map((item, index) => {
                                return (
                                  <MenuItem value={item._id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Box>
                      </>
                    ) : null}
                  </>
                ) : null}
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={teacher.fName}
                    placeholder="First Name"
                    onChange={(e) =>
                      setTeacher({ ...teacher, fName: e.target.value })
                    }
                    onBlur={(e) => {
                      setTeacherTouched({ ...teacherTouched, fName: true });
                      setTeacher({ ...teacher, fName: e.target.value.trim() });
                    }}
                  />
                  {teacher.fName.trim() == "" && teacherTouched.fName ? (
                    <span style={{ color: "red" }}>FirstName is required</span>
                  ) : null}
                </div>

                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={teacher.lName}
                    placeholder="Last Name"
                    onChange={(e) =>
                      setTeacher({ ...teacher, lName: e.target.value })
                    }
                    onBlur={(e) => {
                      setTeacherTouched({ ...teacherTouched, lName: true });
                      setTeacher({ ...teacher, lName: e.target.value.trim() });
                    }}
                  />
                  {teacher.lName.trim() == "" && teacherTouched.lName ? (
                    <span style={{ color: "red" }}>LastName is required</span>
                  ) : null}
                </div>
                <div className="form-group mt-4   p-20">
                  <input
                    type="text"
                    className="form-control"
                    value={teacher.email}
                    placeholder="Email"
                    onPaste={(e) =>
                      setTeacher({ ...teacher, email: e.target.value.trim() })
                    }
                    onChange={(e) =>
                      setTeacher({ ...teacher, email: e.target.value })
                    }
                    onBlur={(e) => {
                      setTeacherTouched({ ...teacherTouched, email: true });
                      e.target.value.trim();
                    }}
                  />
                  {teacher.email.trim() == "" && teacherTouched.email ? (
                    <span style={{ color: "red" }}>Email is required</span>
                  ) : !emailRegex.test(teacher.email) &&
                    teacher.email.trim() != "" &&
                    teacherTouched.email ? (
                    <span style={{ color: "red" }}>
                      Email pattern is required
                    </span>
                  ) : null}
                </div>
                {modified.add ? (
                  <>
                    <div className="form-group mt-4   p-20">
                      <input
                        type="text"
                        className="form-control"
                        value={teacher.password}
                        placeholder="Password"
                        onChange={(e) =>
                          setTeacher({ ...teacher, password: e.target.value })
                        }
                        onBlur={(e) => {
                          setTeacherTouched({
                            ...teacherTouched,
                            password: true,
                          });
                          setTeacher({
                            ...teacher,
                            password: e.target.value.trim(),
                          });
                        }}
                      />
                      {teacher.password.trim() == "" &&
                      teacherTouched.password ? (
                        <span style={{ color: "red" }}>
                          Password is required
                        </span>
                      ) : null}
                      <br />
                      <small style={{ color: "red" }}>
                        Password should contain upto 8 characters
                      </small>
                    </div>
                  </>
                ) : null}
              </div>
            </>
          ) : null}
          {modified.delete ? (
            <>
              <div className="col-md-9 text-left  col-9 m-auto">
                <div className="form-group mt-4   p-20">
                  <h6>
                    {`Are you sure to delete this ${
                      currentUser == "admin"
                        ? "Super Admin"
                        : currentUser == "district"
                        ? "District/School Admin"
                        : "Teacher"
                    } `}
                  </h6>
                  <br />
                  <input
                    type="text"
                    readOnly
                    value={
                      currentUser == "admin"
                        ? `${admin.fName} ${admin.lName}`
                        : currentUser == "district"
                        ? `${district.fName} ${district.lName}`
                        : `${teacher.fName} ${teacher.lName}`
                    }
                    className="form-control"
                    placeholder="School Destrict Name"
                  />
                </div>
              </div>
            </>
          ) : null}
          <div className="col-md-9 text-left  col-9 m-auto">
            <div className="form-group p-20">
              {modified.add || modified.edit ? (
                <>
                  <button
                    type="button"
                    className="cta-btn"
                    onClick={() => {
                      if (currentUser == "admin") add_edit_delete_admin();
                      else if (currentUser == "district")
                        add_edit_delete_District();
                      else add_edit_delete_Teacher();
                    }}
                    disabled={
                      modified.add
                        ? ValidationForm("add")
                        : ValidationForm("edit")
                    }
                  >
                    {modified.add ? "Add" : "Edit"}
                  </button>
                </>
              ) : modified.delete ? (
                <>
                  <button
                    type="button"
                    className="cta-btn-red"
                    onClick={() => {
                      if (currentUser == "admin") add_edit_delete_admin();
                      else if (currentUser == "district")
                        add_edit_delete_District();
                      else add_edit_delete_Teacher();
                    }}
                  >
                    Delete
                  </button>
                </>
              ) : null}
            </div>
          </div>

          {/* ----- {`${modify.admin.add}`} */}
        </section>
      </Dialog>
    </section>
  );
}

function TabPanel(props) {
  const { children, value, index, user, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
